
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "UserCredentialList",
  props: {
    crms: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  data() {
    return {
      columns: [{ name: "Número" }, { name: "UF" }, { name: "Tipo" }],
    };
  },
});
